export default "__VITE_ASSET__487b26bd__"